import Vue from 'vue';
import { Toast } from 'vant';

let vm = null;

const install = function (Vue, options) {
    Vue.prototype.$loading = function (message = '加载中...', duration = 0) {
        if (!vm) {
            vm = new Vue({
                data: {
                    visible: false,
                    message: message,
                },
                methods: {
                    show() {
                        this.visible = true;
                        Toast.loading({
                            message: this.message,
                            duration: duration,
                            forbidClick: true,
                            loadingType: 'spinner',
                            overlay: true,
                        });
                    },
                    hide() {
                        this.visible = false;
                        Toast.clear();
                    },
                },
            });
        }
        vm.show();
        return vm;
    };
};

export default { install };
